import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Modal from '../common/Modal';

function AssetRequestDecisionModal({ id, decision, onClose }) {
  const initials = decision?.loginDecided
    ? `${decision.loginDecided.firstname?.[0] || ''}${decision.loginDecided.lastname?.[0] || ''}`.trim().toUpperCase() || '—'
    : '—';

  const decisionText = decision?.decision ? 'Approved' : 'Rejected';
  const decisionDate = decision?.decisionDate ? moment(decision.decisionDate).format('MMMM D, YYYY • HH:mm') : 'Unknown';

  return (
    <Modal
      id={id}
      title="Decision details"
      icon="pe-7s-comment"
      iconGradient="bg-night-fade"
      contentClass="modal-body-center-h"
      confirmText="Close"
      confirmHandler={() => {}}
      closeHandler={onClose}
      hideCancelButton>
      <div className="decision-info-container">
        <div className="decision-info-box">
          <span className="decision-label">Decision</span>
          <h5 className={`decision-value ${decision?.decision ? 'text-success' : 'text-danger'}`}>{decisionText}</h5>
          <p className="decision-subtext">{decisionDate}</p>
        </div>

        <div className="decision-info-box">
          <span className="decision-label">Decided by</span>
          {decision?.loginDecided ? (
            <div className="decision-user">
              <div className="decision-avatar">{initials}</div>
              <div>
                <h6 className="decision-user-name">
                  {decision.loginDecided.firstname} {decision.loginDecided.lastname}
                </h6>
                <p className="decision-user-meta">
                  {decision.loginDecided.tenantName || 'Unknown tenant'} • {decision.loginDecided.email || 'No email'}
                </p>
              </div>
            </div>
          ) : (
            <p className="decision-empty">No user information available.</p>
          )}
        </div>

        <div className="decision-info-box">
          <span className="decision-label">Comment</span>
          <p className="decision-comment">{decision?.comment || 'No comment provided.'}</p>
        </div>
      </div>
    </Modal>
  );
}

AssetRequestDecisionModal.propTypes = {
  id: PropTypes.string.isRequired,
  decision: PropTypes.shape({
    decision: PropTypes.bool,
    comment: PropTypes.string,
    decisionDate: PropTypes.string,
    loginDecided: PropTypes.shape({
      firstname: PropTypes.string,
      lastname: PropTypes.string,
      email: PropTypes.string,
      tenantName: PropTypes.string,
    }),
  }),
  onClose: PropTypes.func,
};

AssetRequestDecisionModal.defaultProps = {
  decision: null,
  onClose: () => {},
};

export default memo(AssetRequestDecisionModal);

